import { Component } from "@angular/core";
import {IonicPage, MenuController, NavController, NavParams, Platform} from "ionic-angular";
import { AdminLoginPage } from "../admin-login/admin-login";
import {AdminWelcomePage} from "../admin-welcome/admin-welcome";
import {AdminAcknowledgmentsPage} from "../admin-acknowledgments/admin-acknowledgments";
import {AdminBiblioPage} from "../admin-biblio/admin-biblio";
import {AdminEmailsPage} from "../admin-emails/admin-emails";
import {AuthAdminService} from "../../services/authAdminService";
import {AdminConfigPage} from "../admin-config/admin-config";
import {AdminUsagePage} from "../admin-usage/admin-usage";

@IonicPage()
@Component({
  selector: "page-admin-home",
  templateUrl: "admin-home.html"
})
export class AdminHomePage {

  root = AdminWelcomePage;

  constructor(public navCtrl: NavController,
              private auth: AuthAdminService,
              public platform: Platform,
              private menu: MenuController,
              public navParams: NavParams) {
    menu.enable(true);
  }

  ionViewDidLoad() {
  }

  goToAcknowledgments() {
    this.goTo(AdminAcknowledgmentsPage);
  }

  goToBiblio() {
    this.goTo(AdminBiblioPage);
  }

  goToConfig() {
    this.goTo(AdminConfigPage);
  }

  goToEmails() {
    this.goTo(AdminEmailsPage);
  }

  goToUsage() {
    this.goTo(AdminUsagePage);
  }

  private goTo(page) {
    this.root = page;
    if (this.isMobile) {
      this.menu.close();
    }
  }

  logout() {
    this.auth.logout().then(
      () => this.navCtrl.setRoot(AdminLoginPage)
    );
  }

  get isMobile() {
    return this.platform.is('mobile');
  }

  async ionViewCanEnter() {
    const loggedIn = await this.auth.isLoggedIn();
    if (!loggedIn) {
      setTimeout(() => {
        this.navCtrl.setRoot(AdminLoginPage);
      });
    }
    return loggedIn;
  }
}



// WEBPACK FOOTER //
// ./src/pages/admin-home/admin-home.ts